import { useCallback, useContext } from "react";
import { TranslationKey, Locale, Translations } from "../translations";
import { AuthenticatorSettingsContext } from "../AuthenticationProvider";

const FALLBACK = "en";

export const useTranslation = (): {
  t: (key: TranslationKey | `LOGIN_WITH_QRCODE_STEPS_${0 | 1 | 2}`) => string;
} => {
  const { locale } = useContext(AuthenticatorSettingsContext) ?? {};
  const t = useCallback(
    (key: TranslationKey | `LOGIN_WITH_QRCODE_STEPS_${0 | 1 | 2}`) => {
      const localeTranslations = Translations[locale as Locale];
      if (localeTranslations && localeTranslations[key]) {
        return localeTranslations[key] as string;
      }
      return Translations[FALLBACK][key];
    },
    [locale],
  );

  return {
    t,
  };
};
